/**
 * Builds the complete report URL for a spot.
 *
 * Accepts either a legacy SpotRecord array (see Data/SpotRecord.js) or an object with
 * spot_id, fav_spot_id, lat and lon. Station spots use /spot/<id>, favorite-only spots use
 * /favspot/<id>, and arbitrary spots use the routed /spot/<lat>/<lon> form. The older
 * SpotInfo.aspx?latlon= query form is still accepted by the server, but new links should use
 * the routed URL.
 *
 * `base` is prepended to the path. It defaults to the origin; pass '..' for a relative link.
 */
function normalize(spot) {
  if (Array.isArray(spot)) {
    const record = jweather.Data.SpotRecord;

    return {
      spotId: spot[record.spot_id],
      favSpotId: spot[record.fav_spot_id],
      lat: spot[record.lat],
      lon: spot[record.lon],
    };
  }

  return {
    spotId: spot.spot_id,
    favSpotId: spot.fav_spot_id,
    lat: spot.lat,
    lon: spot.lon,
  };
}

export default function completeReportUrl(spot, base = window.location.origin) {
  const { spotId, favSpotId, lat, lon } = normalize(spot);

  if (spotId != null) {
    return `${base}/spot/${spotId}`;
  }

  if (favSpotId != null) {
    return `${base}/favspot/${favSpotId}`;
  }

  if (lat != null && lon != null) {
    return `${base}/spot/${lat}/${lon}`;
  }

  return null;
}
